import { Button } from '@/components/atoms/button'
import { NavigationMenuDesktop } from '@/components/organisms/navigation-menu-desktop'
import { NavigationMenuMobile } from '@/components/organisms/navigation-menu-mobile'
import { List } from 'phosphor-react'

export function NavigationMenu() {
  return (
    <>
      <NavigationMenuMobile className="block lg:hidden">
        <Button variant="ghost" size="icon" aria-label="Abrir menu">
          <List size={24} />
        </Button>
      </NavigationMenuMobile>

      <div className="flex items-center justify-center w-full md:justify-center">
        <NavigationMenuDesktop className="hidden lg:block" />
      </div>
    </>
  )
}
